import { useGetAuthData } from "@/lib/hooks"

export function Settings() {
  const { data, error, refetch } = useGetAuthData()

  return <div>Settdings</div>
}
